import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const resumePath = "/resume.pdf";

const Education = () => {
  return (
    <section id="resume">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.5 } }}
        className="w-full flex flex-col lgl:flex-row gap-10"
      >


        {/* Part Two */}
        
        <div className="flex-1 flex flex-col items-center">
          <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
            <h2 className="text-3xl md:text-4xl font-bold">Experience</h2>
          </div>
          <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
            <ResumeCard
              title="Software Engineer Intern"
              subTitle="Innovative Defense Technologies    (May - Dec 2025)"
              result="Mt. Laurel, NJ"
              des={`• Migrated legacy vSphere services to Azure using the Azure Python SDK, enabling DoD cloud testing for Navy ships and fighter jets

• Built 120+ unit tests across vSphere, Azure, and AWS in a Jenkins CI/CD pipeline, improving API security and catching 3 critical bugs`}
              style={{ whiteSpace: "pre-line" }}
            />
            <ResumeCard
              title="Teaching Assistant"
              subTitle="Villanova University - (Aug 2024 - May 2025)"
              result="Villanova, PA"
              des={`• Held weekly office hours to explain dynamic programming, greedy algorithms, and divide-and-conquer techniques,
guiding over 100+ students through complex concepts

• Mentored students in debugging and optimizing algorithms, grading 500+ assignments to assess and improve their
problem-solving skills, resulting in a 20% average improvement in assignment scores`}
            />
            <ResumeCard
              title="Research Assistant"
              subTitle="Villanova University (Jan 2023 - May 2023)"
              result="Villanova, PA"
              des={`• Conducted extensive research on dataset image redundancy reduction, utilizing open-source deep-learning
algorithms for recognition and matching experiments, leading to a 25% reduction in redundant data

• Improved image recognition model accuracy by over 40%, creating streamlined and precise models that significantly
enhanced data-driven application quality and effectiveness`}
            />
          </div>
        </div>

        {/* Part One */}
        <div className="flex-1 flex flex-col items-center">
          <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
            <h2 className="text-3xl md:text-4xl font-bold">Education</h2>
          </div>
          <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
            <ResumeCard
              title="Villanova University"
              subTitle="Bachelor of Science in Computer Science (2022 - 2025)"
              result="GPA: 3.9/4.0"
              des={`Deans List every semester
            
Relevant Coursework: 
•Large Language Models (LLMs)
•Competitive Programming
•Operating Systems
•Database Management Systems
•Software Engingeering`}
            />
            <ResumeCard
              title="James Madison High School"
              result="GPA: 4.0/4.0"
              des="Graduate of the year (Valedictorian)"
            />
            {/* Download Resume Card */}
            <ResumeCard
              title="Certifications"
              des="Microsoft Azure Cloud Fundamentals"
              result=""
              subTitle=""
            />
            <ResumeCard
              title="Download Full Resume"
              des="Click the button below to download my complete resume as a PDF."
              result=""
              subTitle=""
              additionalContent={
                <a
                  href={resumePath}
                  download="resume.pdf"
                  className="px-4 py-2 mt-4 text-white bg-designColor rounded-lg hover:bg-opacity-80 transition"
                >
                  Download Resume
                </a>
              }
            />
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Education;
